import { ApiQuickInsightCategory } from "@incendium/api";
import { People, PersonAdd, Schedule, ShoppingCart } from "@mui/icons-material";
import { SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";

const categoryMap: Record<
  Exclude<ApiQuickInsightCategory, ApiQuickInsightCategory.UNSPECIFIED>,
  {
    icon: OverridableComponent<SvgIconTypeMap<{}, "svg">> & { muiName: string };
    color: string;
    title: string;
  }
> = {
  [ApiQuickInsightCategory.CUSTOMERS_RETENTION]: {
    icon: People,
    color: "#4046c2",
    title: "Customers & Retention",
  },
  [ApiQuickInsightCategory.TIMING]: {
    icon: Schedule,
    color: "#8251db",
    title: "Timing",
  },
  [ApiQuickInsightCategory.PRODUCT]: {
    icon: ShoppingCart,
    color: "#994ce8",
    title: "Product",
  },
  [ApiQuickInsightCategory.ACQUISITION]: {
    icon: PersonAdd,
    color: "#893dad",
    title: "Acquisition",
  },
};
export const getCategoryIcon = (category: ApiQuickInsightCategory) => {
  return categoryMap[category]?.icon || People;
};
export const getCategoryColor = (category: ApiQuickInsightCategory) => {
  return categoryMap[category]?.color || "#fff";
};
export const getCategoryTitle = (category: ApiQuickInsightCategory) => {
  return categoryMap[category]?.title || "Unknown";
};
